"use client"

import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"
import { cn } from "@shared/utils"
import type { TabsTriggerProps } from "../../interfaces/TabsTriggerProps"

/**
 * @group Components
 * @summary <blockquote>TabsTrigger component renders a clickable tab button.</blockquote>
 * @example
 * ```tsx
 * <TabsTrigger value="tab1" className="custom-tab-trigger">
 *   Tab 1
 * </TabsTrigger>
 * ```
 */
const TabsTrigger = React.forwardRef<
  React.ComponentRef<typeof TabsPrimitive.Trigger>,
  TabsTriggerProps
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
      className
    )}
    {...props}
  />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

export { TabsTrigger } 